import { clampZoomPercent } from './zoom-persistence';

const FIT_GUTTER_PX = 48;

export const FIT_ZOOM_LABEL = 'Fit';

export const fitZoomPercent = ({
  availableWidthPx,
  pageWidthPx,
}: {
  availableWidthPx: number;
  pageWidthPx: number;
}): number => {
  if (pageWidthPx <= 0 || availableWidthPx <= 0) return clampZoomPercent(100);

  const usableWidthPx = Math.max(availableWidthPx - FIT_GUTTER_PX * 2, 1);

  return clampZoomPercent((usableWidthPx / pageWidthPx) * 100);
};
